export function transformMenu(menuList = []) {
  function parseStyle(styleStr) {
    try {
      return JSON.parse(styleStr || '{}')
    } catch {
      return {}
    }
  }

  function deepTransform(list) {
    const result: any = []

    for (const item of list) {
      if (item.menuType === 3) continue // 按钮不生成路由

      const style = parseStyle(item.style)

      const node: any = {
        path: item.routeName || '',
        component: item.component || '#',
        name: style.componentName || `menu_${item.id}`,
        id: item.id,
        meta: {
          title: item.menuName || '',
          icon: item.icon || '',
          hidden: item.isVisible === '1',
          noCache: item.isCache === '1',
          activeMenu: style.activeMenu || '',
          permission: [],
          alwaysShow: item.menuName == '首页' ? false : item.component == '#'
        }
      }

      // 筛出按钮权限
      const perms = (item.children || [])
        .filter((c) => c.menuType === 3)
        .map((c) => (c.perms && c.perms.trim()) || c.menuName?.trim())
        .filter(Boolean)

      if (perms.length > 0) node.meta.permission = perms

      // 递归子菜单
      const childMenus = (item.children || []).filter((c) => c.menuType !== 3)
      if (childMenus.length > 0) node.children = deepTransform(childMenus)

      result.push(node)
    }

    return result
  }

  return deepTransform(menuList)
}

export function getFirstMenuFullPath(routes, parentPath = '', isRoot = true) {
  for (const route of routes) {
    // 处理路径拼接，确保正确的路由格式
    const currentPath = route.path.startsWith('/') ? route.path : `${parentPath}/${route.path}`

    // 非根节点且可见的路由
    if (!isRoot && route.meta?.hidden !== true) {
      // 优先返回有子菜单的路由（原逻辑）
      if (route.children?.length) {
        return currentPath
      }
      // 新增：如果没有子菜单，但自身是可见的有效路由（如工作台），也作为候选
      else {
        // 先暂存这个独立路由，继续检查是否有更优先的带子女路由
        const childResult = route.children
          ? getFirstMenuFullPath(route.children, currentPath, false)
          : null
        // 如果子路由中没有找到更合适的，就返回当前这个独立路由
        if (!childResult) {
          return currentPath
        } else {
          return childResult
        }
      }
    }

    // 递归处理子路由
    if (route.children?.length) {
      const childPath = getFirstMenuFullPath(route.children, currentPath, false)
      if (childPath) return childPath
    }
  }
  return null
}
